var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('keep-alive',{attrs:{"exclude":['UserRolesList', 'UserRolePreview']}},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('core-app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }